import React from 'react'

const VendorHome = () => {
  return (
    <div>VendorHome</div>
  )
}

export default VendorHome